/*
 * @Author: jay
 * @Date: 2021-07-15 14:19:08
 * @LastEditTime: 2021-08-27 09:01:33
 * @Description: file content
 */
import Loadable from 'react-loadable';
import {Spin} from 'antd';

export default (loader:any,render?:any)=>{
    if(!render){
        return Loadable({
            loader,
            loading: () => (<div className="loading"><Spin size="large" /></div>)
        })
    }
    return Loadable({
        loader,
        loading: () => (<div className="loading"><Spin size="large" /></div>),
        render
    })
}